export default __webpack_public_path__ + "static/stacked-bar-82953436d9b8d63c0c3b1efd254175aa.png";